<template>
	<Teleport to="body">
		<div
			v-if="url"
			class="g-edit-media-player-overlay"
			@click.self="onClose"
		>
			<button
				type="button"
				class="g-edit-media-player-overlay__close"
				@click="onClose"
			>关闭</button>
			<video
				v-if="kind === 'video'"
				ref="playerEl"
				class="g-edit-media-player-overlay__media"
				:src="url"
				controls
				playsinline
				autoplay
				@ended="onClose"
			></video>
			<audio
				v-else
				ref="playerEl"
				class="g-edit-media-player-overlay__audio"
				:src="url"
				controls
				autoplay
				@ended="onClose"
			></audio>
		</div>
	</Teleport>
</template>

<script>
	export default {
		name: 'GEditMediaPlayerOverlay',
		props: {
			url: {
				type: String,
				default: '',
			},
			kind: {
				type: String,
				default: 'video',
			},
		},
		emits: ['close'],
		watch: {
			url(value) {
				if (!value) return;
				this.$nextTick(() => {
					this.$refs.playerEl?.play?.().catch?.(() => {});
				});
			},
		},
		beforeUnmount() {
			this.pausePlayer();
		},
		methods: {
			pausePlayer() {
				const el = this.$refs.playerEl;
				if (el) {
					el.pause?.();
				}
			},
			onClose() {
				this.pausePlayer();
				this.$emit('close');
			},
		},
	};
</script>

<style scoped lang="less">
	.g-edit-media-player-overlay {
		position: fixed;
		inset: 0;
		z-index: 11000;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 48px 24px 24px;
		box-sizing: border-box;
		background: rgba(0, 0, 0, 0.72);
	}

	.g-edit-media-player-overlay__close {
		position: absolute;
		top: 16px;
		right: 16px;
		z-index: 1;
		height: 32px;
		padding: 0 14px;
		border: none;
		border-radius: 4px;
		background: rgba(255, 255, 255, 0.92);
		color: #333;
		font-size: 13px;
		cursor: pointer;
	}

	.g-edit-media-player-overlay__media {
		display: block;
		width: ~"min(960px, 100%)";
		max-height: calc(100vh - 96px);
		background: #000;
		outline: none;
	}

	.g-edit-media-player-overlay__audio {
		width: ~"min(480px, 100%)";
		outline: none;
		height: 200px;
	}
</style>
